import { UNKNOWN_REASONS } from '@ion/api/audit-logs/format';

export default {
  // Also the reason for a record type whose creation is never audited (pipeline variables, users),
  // so the text must not claim anything was pruned.
  [UNKNOWN_REASONS.PREDECESSOR_PRUNED]:
    'The previous value is unknown: no earlier audit entry for this record exists in the last 90 days.',
  [UNKNOWN_REASONS.PREDECESSOR_UNAVAILABLE]: 'The previous value could not be loaded.',
  [UNKNOWN_REASONS.KEY_ABSENT_FROM_PREDECESSOR]: 'The preceding entry did not record this field.',
  [UNKNOWN_REASONS.FOREIGN_LOOKUP_MISSED]: 'The writer’s lookup of this value missed.',
};
